import { imageCoverContainer } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import { h1 } from '@helpers/typography';
import { ArticleCardStyles } from '@stories/Components/Cards/ArticleCard/ArticleCard.styles';
import { SearchResultCardStyles } from '@stories/Components/Cards/SearchResultCard/SearchResultCard.styles';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Global/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
import { InnerPageBannerStyles } from '../InnerPageBanner/InnerPageBanner.styles';
const Container = styled(SectionWrapper) `
  position: relative;

  ${SectionWrapperStyles.SiteWide} {
    margin: 0 0 0 auto;
    --containerWidth: calc(var(--siteWidth) + var(--sitePadding) + var(--sitePadding));
    --offsetWidth: calc(calc(100vw - var(--containerWidth)) / 2);
    max-width: calc(var(--containerWidth) + var(--offsetWidth));
    padding: 0 0 0 var(--sitePadding);

    @media ${until(Device.Tablet)} {
      padding-left: 0;
      padding-right: 0;
    }
  }
`;
const Inner = styled.div `
  border-left: ${fluid(10, 20)} solid var(--themeColor);
`;
const MediaArea = styled.div `
  position: relative;

  @media ${until(Device.Tablet)} {
    min-height: 200px;
  }
`;
const PromoImage = styled.img `
  width: 100%;
  height: 100%;
  object-fit: cover;

  @media ${until(Device.Tablet)} {
    ${imageCoverContainer()};
  }
`;
const CitationBtn = styled(InnerPageBannerStyles.CitationBtn) ``;
const CitationIcon = styled(InnerPageBannerStyles.CitationIcon) ``;
const CitationContent = styled(InnerPageBannerStyles.CitationContent) ``;
const ContentArea = styled.div `
  background-color: ${brand.grey.grey91};
  padding: 18px 37px ${fluid(21, 44)} ${fluid(26, 118)};

  > * {
    max-width: 880px;
  }
`;
const BannerTitle = styled.h1 `
  ${h1};
  margin-bottom: 16px;
`;
const CategoryTags = styled(SearchResultCardStyles.Categories) `
  margin-top: 8px;

  svg,
  span,
  a {
    color: var(--themeColor);
  }

  svg {
    top: 6px;
  }

  span {
    font-size: ${fluid(14, 18)};
    line-height: ${fluid(16, 24)};
    ${fonts.agBook.regular};
  }

  a {
    &:hover {
      span {
        text-decoration: underline;
      }
    }

    &:not(:last-child) {
      &::after {
        content: ',';
        margin-right: 5px;
      }
    }
  }
`;
const Date = styled(ArticleCardStyles.ArticleInfoItem) `
  font-size: ${fluid(14, 18)};
  line-height: ${fluid(16, 24)};
  ${fonts.agBook.regular};
`;
const DateIcon = styled(ArticleCardStyles.ArticleInfoItemIcon) `
  position: relative;
  top: -2px;
`;
export const ArticleBannerStyles = {
    BannerTitle,
    CategoryTags,
    CitationBtn,
    CitationContent,
    CitationIcon,
    Container,
    ContentArea,
    Date,
    DateIcon,
    Inner,
    MediaArea,
    PromoImage,
};
